var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { getColor, getSizeBy } from "../../theme/utils";
import Flex from "../templates/flex";
export var StyledTabsWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column nowrap;\n"], ["\n  display: flex;\n  flex-flow: column nowrap;\n"])));
export var StyledTabs = styled.nav(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n  align-items: center;\n\n  border-bottom: 1px solid\n    ", ";\n  box-sizing: border-box;\n\n  padding: 0 2px;\n"], ["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n  align-items: center;\n\n  border-bottom: 1px solid\n    ", ";\n  box-sizing: border-box;\n\n  padding: 0 2px;\n"])), function (_a) {
    var noDefaultBorder = _a.noDefaultBorder;
    return noDefaultBorder ? getColor(["transparent", "full"]) : getColor("borderSecondary");
});
export var StyledTab = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-bottom: ", " solid\n    ", ";\n  box-sizing: border-box;\n\n  min-width: ", ";\n  max-width: ", ";\n  height: ", ";\n  color: ", ";\n  font-weight: ", ";\n\n  cursor: pointer;\n  opacity: ", ";\n  pointer-events: ", ";\n\n  &:hover {\n    border-bottom: ", " solid ", ";\n  }\n\n  & > span {\n    font-weight: ", ";\n  }\n"], ["\n  border-bottom: ", " solid\n    ", ";\n  box-sizing: border-box;\n\n  min-width: ", ";\n  max-width: ", ";\n  height: ", ";\n  color: ", ";\n  font-weight: ", ";\n\n  cursor: pointer;\n  opacity: ", ";\n  pointer-events: ", ";\n\n  &:hover {\n    border-bottom: ", " solid ", ";\n  }\n\n  & > span {\n    font-weight: ", ";\n  }\n"])), function (_a) {
    var small = _a.small;
    return (small ? "2px" : "4px");
}, function (_a) {
    var active = _a.active;
    return (active ? getColor("accent") : getColor(["transparent", "full"]));
}, function (_a) {
    var minWidth = _a.minWidth;
    return minWidth !== null && minWidth !== void 0 ? minWidth : getSizeBy(10);
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth !== null && maxWidth !== void 0 ? maxWidth : getSizeBy(26);
}, function (_a) {
    var small = _a.small;
    return (small ? getSizeBy(4) : getSizeBy(6));
}, getColor("text"), function (_a) {
    var active = _a.active;
    return (active ? "bold" : "normal");
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.4 : 1);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? "none" : "auto");
}, function (_a) {
    var small = _a.small;
    return (small ? "2px" : "4px");
}, getColor("primary"), function (_a) {
    var active = _a.active;
    return (active ? "bold" : "normal");
});
var templateObject_1, templateObject_2, templateObject_3;
